export const SUBMIT_PROFILE_LOADING = "SUBMIT_PROFILE_LOADING"
export const GET_PROFILE_FORM = "GET_PROFILE_FORM"
export const UPDATE_PROFILE_FORM = "UPDATE_PROFILE_FORM"
export const SUBMIT_UPDATE_PASSWORD_SUCCESS = "SUBMIT_UPDATE_PASSWORD_SUCCESS"
export const UPDATE_PROFILE_IMG_ECM = "UPDATE_PROFILE_IMG_ECM"
export const GET_CREDIT_DATA = "GET_CREDIT_DATA"
export const GET_CALLBACK_FORM = "GET_CALLBACK_FORM"